import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const NewSegmentModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string) => void;
  isSubmitting?: boolean;
}> = ({ isOpen, onClose, onCreate, isSubmitting }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (isOpen) setName("");
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCreate = () => {
    if (!name.trim()) return;
    onCreate(name.trim());
  };

  return (
    <div className="fixed -inset-7 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className="relative bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-sm p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-1">
          <h3 className="text-base font-bold text-gray-900 dark:text-gray-100">New Segment</h3>
          <button
            onClick={onClose}
            className="p-1 rounded-full text-[#7B7B7B] font-semibold dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 bg-transparent border-none cursor-pointer"
          >
            <X size={16} />
          </button>
        </div>
        <p className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500 mb-4">Create a new segment</p>

        <label className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Segment Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleCreate()}
          placeholder="Segment name e.g. High Value Email Segment"
          autoFocus
          disabled={isSubmitting}
          className="w-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-indigo-400 mb-4 disabled:bg-gray-50 dark:disabled:bg-gray-800"
        />

        <button
          onClick={handleCreate}
          disabled={!name.trim() || isSubmitting}
          className="w-full py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed mb-2"
        >
          {isSubmitting ? "Creating..." : "Create"}
        </button>
        <button
          onClick={onClose}
          disabled={isSubmitting}
          className="w-full py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default NewSegmentModal;
